import React from 'react'
import clxs from 'clsx'
import { Button, ButtonProps } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import { transparentize } from 'polished'
import { extractPrimaryColorFromPallete } from '~/utils/themeHelpers'
import { mutualTheme } from '~/utils/theme'

const useStyles = makeStyles({
  button: {
    backgroundColor: (props: ButtonProps) => props.color ? transparentize(0.9, extractPrimaryColorFromPallete(props.color)) : undefined,
    color: (props: ButtonProps) => props.color ? extractPrimaryColorFromPallete(props.color) : undefined
  },
  disabledButton: {
    backgroundColor: mutualTheme.palette.grey[200],
    color: mutualTheme.palette.grey[500]
  }
})

export const SecondaryButton: React.FC<ButtonProps> = (props) => {
  const classes = useStyles(props)

  return (
    <Button
      {...props}
      className={clxs(props.className, {
        [classes.button]: !props.disabled,
        [classes.disabledButton]: props.disabled
      })}
    />
  )
}
